import styles from './signupbutton.module.css';

const SignupButton = ({ ctaLink, text }) => {
    return (
        <div className={styles.signupButton} onClick={() => window.location.href = ctaLink}>
            <h6>{text}</h6><span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.175 9H0V7H12.175L6.575 1.4L8 0L16 8L8 16L6.575 14.6L12.175 9Z" fill="black"></path>
</svg></span>
        </div>
    );
}

export default SignupButton;
